"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(event) {
    return ['LATENCY', 'HISTORY', event];
}
exports.transformArguments = transformArguments;
